// extracted by mini-css-extract-plugin
export default {"leftBlock":"BimEditOtherLimit_leftBlock__Oi7nk","wrapperFields":"BimEditOtherLimit_wrapperFields__0Ap9S","labelBlock":"BimEditOtherLimit_labelBlock__rKQC9"};